import React, { useState } from "react";
import { Bookmark, X, KeyRound } from "lucide-react";
import { useLang } from "@/i18n";

export const SavePageNotice = () => {
  const { lang } = useLang();
  const [open, setOpen] = useState(() => localStorage.getItem("guardia_save_notice") !== "hidden");
  if (!open) return null;
  const close = () => { localStorage.setItem("guardia_save_notice", "hidden"); setOpen(false); };
  const it = lang === "it";
  return (
    <div data-testid="save-page-notice" className="relative mb-5 overflow-hidden rounded-xl border border-[#E63946]/40 bg-gradient-to-r from-[#E63946]/15 via-[#14161b] to-[#14161b] p-5">
      <button onClick={close} data-testid="save-page-notice-close" className="absolute top-3 right-3 p-1 text-zinc-500 hover:text-white"><X size={16} /></button>
      <div className="flex items-start gap-4">
        <span className="shrink-0 grid place-items-center w-11 h-11 rounded-full bg-[#E63946] text-white"><Bookmark size={20} /></span>
        <div className="pr-6">
          <p className="font-heading text-xl font-extrabold uppercase text-white tracking-wide">
            {it ? "Salva questa pagina, campione" : "Save this page, champ"}
          </p>
          <p className="mt-1 text-sm text-zinc-300 leading-relaxed">
            {it ? "Aggiungila ai preferiti (Ctrl+D, oppure Condividi → Aggiungi a Home sul telefono): da questo browser resterai sempre connesso alla tua console." : "Bookmark it (Ctrl+D, or Share → Add to Home Screen on mobile): on this browser you'll stay signed in to your console."}
          </p>
          <p className="mt-3 flex items-start gap-2 text-xs text-zinc-400">
            <KeyRound size={14} className="shrink-0 mt-0.5 text-[#E63946]" />
            {it ? "Su un altro dispositivo usa il link personale dell'email di acquisto (contiene il tuo codice di accesso, non condividerlo) oppure \"Ho già accesso\" nella pagina Blueprint." : "On another device use the personal link in your purchase email (it contains your access code, don't share it) or \"I already have access\" on the Blueprint page."}
          </p>
        </div>
      </div>
    </div>
  );
};
